import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import VerifyCode from './components/VerifyCode';
import SetNewPassword from './components/SetNewPassword';
import SignUp from './components/SignUp';
import SetPassword from './components/SetPassword';
import Home from './components/Home';
import Booking from './components/Booking';
import SearchResult from './components/SearchResult';
import SearchHistory from './components/SearchHistory';
import ProfileWorker from './components/ProfileWorker';
import MyProfile from './components/MyProfile';

function RequireAuth({ children }) {
  if (localStorage.getItem('isLoggedIn') !== 'true') {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          localStorage.getItem('isLoggedIn') === 'true' ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />
        } />
        <Route path="/home" element={<RequireAuth><Home /></RequireAuth>} />
        <Route path="/booking" element={<RequireAuth><Booking /></RequireAuth>} />
        <Route path="/search" element={<RequireAuth><SearchHistory /></RequireAuth>} />
        <Route path="/search-result" element={<RequireAuth><SearchResult /></RequireAuth>} />
        <Route path="/profile" element={<RequireAuth><ProfileWorker /></RequireAuth>} />
        <Route path="/my-profile" element={<RequireAuth><MyProfile /></RequireAuth>} />
        {/* Auth routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-code" element={<VerifyCode />} />
        <Route path="/set-new-password" element={<SetNewPassword />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/set-password" element={<SetPassword />} />
      </Routes>
    </Router>
  );
}

export default App; 